<template>
  <scroll-center-dialog v-model="opened" :loading="save_loading" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <v-text-field
        v-model="car.number"
        label="Номер автомобиля"
        outlined
        class="mt-4"
        :error="hasError('number')"
        :error-messages="getError('number')"
    >
      <template v-slot:label>
        Номер автомобиля <strong class="red--text">*</strong>
      </template>
    </v-text-field>
    <v-row no-gutters class="text-left mb-7" v-if="!edit_model">
      <v-col cols="11" class="text--secondary" style="border: rgb(0, 0, 0, 50%) 1px solid; border-radius: 5px; padding: 16px 12px">
        <strong>Марка автомобиля: </strong>
        <span v-if="edit">{{ car.model }}</span>
      </v-col>
      <v-col cols="1" class="mt-2 mt-sm-2 pl-sm-2">
        <v-btn
            fab
            icon
            small
            color="primary"
            @click="() => {this.edit_model = true; this.car.model = ''}"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                  v-bind="attrs"
                  v-on="on"
              >
                close
              </v-icon>
            </template>
            <span>Изменить</span>
          </v-tooltip>
        </v-btn>
      </v-col>
    </v-row>
    <loading-autocomplete
        v-if="edit_model"
        placeholder="Введите название и выберете из предложенных вариантов"
        label="Марка автомобиля"
        outlined
        required
        v-model="car.model"
        search-parameter="search"
        :url="car_selector"
        :error="hasError('model')"
        :error-messages="getError('model')"
        :item-text="getText"
        :load-fios="false"
        :menu-props="{ maxWidth: 575, maxHeight: 150 }"
    >
      <template v-slot:no-data>
        <div>
          Для поиска начните набирать название, <br> и подождите 1 секунду, либо нажмите Enter
        </div>
      </template>
    </loading-autocomplete>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import loadingAutocomplete from "@/modules/core/components/LoadingAutocomplete.vue";
import selectors from "@/urls/selectors";

export default {
  name: "CarsEditDialog",
  props: {
    opened: Boolean,
    edit: Boolean,
    carData: Object
  },
  mixins: [FormErrorsMixin, PaginatedDataMapperMixin],
  components: {
    ScrollCenterDialog,
    loadingAutocomplete
  },
  data() {
    return {
      save_loading: false,
      edit_model: true,
      car_default: {
        model: "",
        number: ""
      },
      car: undefined,
      selectors: {
        models: []
      }
    }
  },
  computed: {
    form_title () {
      return this.edit === false ? "Добавить автомобиль" : "Редактировать автомобиль"
    },
    car_selector(){
      return selectors.SELECTORS.CARS.MODELS()
    }
  },
  methods: {
    ...mapActions({
      createCars: "admin/createCars",
      changeCars: "admin/changeCars"
    }),
    close(){
      this.$emit("close", false)
    },
    loadCarsData(){
      if(this.carData === undefined){
        this.car = this.car_default
      }
      else{
        this.car = JSON.parse(JSON.stringify(this.carData))
        if (this.edit) this.edit_model = false
      }
    },
    // Определения значения при редактировании
    choicesTextToValue(text, choices) {
      let typeValue = this.choices[choices].find(
          item => {
            if (item.text === text) {
              return item
            }
          }
      )
      if (typeValue) {
        return typeValue.value
      }
      return null
    },
    save(){
      this.save_loading = true
      if (this.edit) {
        this.changeCars({
          data: this.car,
          finalizer: (val) => {
            this.$emit("close", this.car)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      }else {
        this.createCars({
          data: this.car,
          finalizer: (val) => {
            this.$emit("close", this.car)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      }
    },
    getText(value){
      if(value !== undefined)
        return `${value.text}`
      else
        return ""
    }
  },
  created() {
    this.loadCarsData()
  }
}
</script>

<style scoped>

</style>
